// Common ForwardHealth PA denial reasons. RNs pick from this list first,
// then add detail via free text or voice dictation.

export const DENIAL_REASONS = [
  {
    code: "medical_necessity",
    label: "Medical necessity not established",
    tip: "ForwardHealth couldn't tie documented ADL deficits to the PC level requested.",
  },
  {
    code: "insufficient_documentation",
    label: "Insufficient documentation",
    tip: "Missing narrative support on F-11133/F-11136 or gaps in the clinical picture.",
  },
  {
    code: "hours_exceed_guidelines",
    label: "Hours exceed medical necessity",
    tip: "Weekly hours requested exceeded what's supported by ADL scores and MOT elements.",
  },
  {
    code: "duplicate_services",
    label: "Duplicates informal caregiver",
    tip: "Requested hours overlap with documented unpaid caregiver availability.",
  },
  {
    code: "safety_concerns",
    label: "Safety / supervision concerns",
    tip: "Client requires a higher level of care than PCW can safely provide.",
  },
  {
    code: "cms485_missing",
    label: "CMS-485 not received / unsigned",
    tip: "Plan of Care missing or physician signature not returned in time.",
  },
  {
    code: "member_ineligible",
    label: "Member not eligible at requested dates",
    tip: "Medicaid coverage gap or enrollment change during cert period.",
  },
  {
    code: "member_institutionalized",
    label: "Member in higher level of care",
    tip: "Member admitted to nursing facility or hospital.",
  },
  {
    code: "pcst_incomplete",
    label: "PCST F-11133 incomplete",
    tip: "Missing required elements or inconsistent scoring across sections.",
  },
  {
    code: "pcw_unqualified",
    label: "PCW training/competency not documented",
    tip: "Delegation records insufficient for Part III tasks.",
  },
  {
    code: "service_area",
    label: "Out of service area",
    tip: "Agency not enrolled to serve the member's county or region.",
  },
  {
    code: "other",
    label: "Other — specify in note",
    tip: "Use this when ForwardHealth gave a reason not in this list.",
  },
];

export function denialLabel(code) {
  return DENIAL_REASONS.find((r) => r.code === code)?.label || code || "Denial";
}
